<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import { Link } from "svelte-navigator";
    import { Button, ButtonGroup } from "sveltestrap";
    import type { Form } from "../Model/Form";
    import { formsService } from "../services";
    import FormStatusControl from "./FormStatusControl.svelte";

    export let forms: Form[];

    const dispatch = createEventDispatcher();

    async function duplicateForm(form: Form): Promise<void> {
        if (!confirm('¿Esta seguro de querer duplicar este formulario?')) {
            return;
        }
        const dupId = await formsService.duplicateForm(form.id);
        const dup = await formsService.findOne(dupId);
        dispatch('duplicated', dup);
    }

    async function deleteForm(form: Form): Promise<void> {
        if (!confirm('¿Esta seguro de querer eliminar definitivamente el formulario?')) {
            return;
        }
        try {
            await formsService.removeForm(form.id);
            form.disabled = true;
            dispatch('removed', form);
        } catch (error) {
            console.error(error);
        }
    }

</script>

<table class="mt-3 table">
    <thead>
        <tr>
            <th scope="col">#</th>
            <th scope="col">Nombre</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
        </tr>
    </thead>
    <tbody>
        {#key forms}
        {#each forms as form, index}
            <tr>
                <th scope="row">{index + 1}</th>
                <td><Link to="/formulario/{form.id}">{form.name || 'Formulario sin nombre'}</Link></td>
                <td>
                    <FormStatusControl {form} on:enabled on:disabled />
                </td>
                <td class="text-end">
                    <ButtonGroup>
                        <Button size="sm" color="warning" on:click={() => duplicateForm(form)}>Duplicar</Button>
                        <Button size="sm" color="danger" on:click={() => deleteForm(form)}>Eliminar</Button>
                    </ButtonGroup>
                </td>
            </tr>
        {/each}
        {/key}
    </tbody>
</table>